import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import BookingCompanyNotice from "@/components/feature/BookingCompanyNotice";
import { img } from "@/lib/images";

const adventures = [
  {
    slug: "adventure-01",
    img: img("activities/adventure-tours/adventure-tours-rafting-01.jpg"),
    titleKey: "adventure_1_title",
    descKey: "adventure_1_desc",
    tagKey: "adventure_1_tag",
  },
  {
    slug: "adventure-02",
    img: img("activities/adventure-tours/adventure-tours-sailing-01.jpg"),
    titleKey: "adventure_2_title",
    descKey: "adventure_2_desc",
    tagKey: "adventure_2_tag",
  },
  {
    slug: "adventure-03",
    img: img("activities/adventure-tours/adventure-tours-diving-01.jpg"),
    titleKey: "adventure_3_title",
    descKey: "adventure_3_desc",
    tagKey: "adventure_3_tag",
  },
  {
    slug: "adventure-04",
    img: img("activities/adventure-tours/atventure-tours-diving-tour-01.jpg"),
    titleKey: "adventure_4_title",
    descKey: "adventure_4_desc",
    tagKey: "adventure_4_tag",
  },
];

export default function AdventureToursPage() {
  const { t, i18n } = useTranslation();
  const isDe = i18n.language.startsWith("de");

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("adventure_eyebrow")}
          title={t("adventure_title")}
          subtitle={t("adventure_intro")}
          image={img("activities/adventure-tours/header-adventure-tours-01.jpg")}
          imageAlt="Bali adventure tours"
        />

        <section className="py-8 md:py-12 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center max-w-3xl mx-auto mb-6 md:mb-8">
              <p className="text-foreground-700 leading-relaxed">
                {t("adventure_desc")}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
              {adventures.map((adv, i) => (
                <div
                  key={i}
                  className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-600 transition-all"
                >
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={adv.img}
                      alt={t(adv.titleKey)}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute top-4 right-4 bg-background-50/95 text-foreground-900 text-xs font-semibold px-3 py-1 rounded-full">
                      {t(adv.tagKey)}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">
                      {t(adv.titleKey)}
                    </h3>
                    <div className="w-10 h-0.5 bg-accent-500 mb-4"></div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {t(adv.descKey)}
                    </p>
                    <div className="mt-4 pt-4 border-t border-background-200">
                      <LocalizedLink
                        to={`/tour/${adv.slug}`}
                        className="inline-flex items-center gap-1.5 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-md whitespace-nowrap cursor-pointer transition-colors"
                      >
                        {t("tour_detail_read_more")}
                        <i className="ri-arrow-right-line"></i>
                      </LocalizedLink>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              {t("adventure_heading_1")}
            </h2>
            <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
            <p className="text-foreground-700 leading-relaxed">
              {t("adventure_p1")}
            </p>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                  {t("adventure_cta_title")}
                </h2>
                <p className="mt-2 text-foreground-700 text-sm">
                  {t("adventure_cta_sub")}
                </p>
              </div>
              <LocalizedLink
                to="/your-stay"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-calendar-check-line"></i>
                {t("adventure_book_cta")}
              </LocalizedLink>
            </div>
            <BookingCompanyNotice isDe={isDe} />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}